import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import moment from 'moment';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { merge, get, clone, set, findIndex } from 'lodash';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast, ActionSheet } from 'antd-mobile';
import Tloader from 'react-touch-loader';
import Vfalls from '../../../components/falls';
import { Loading } from '../../../components/loading';
import { TextDialog } from '../../../components/textDialog';
import { getGalleryImgList, setGalleryImgPraise, handleImgData, handleIndexData } from './action';
import { getImgInfo, getDownloadQRCode, sendDownloadInfo } from '../idetail/action';
import { getUploadToken } from '../upload/action';
import { VBottomNav } from '../../../components/copyright/common';
import { VDialogText } from '../../../components/dialog';
import { base64ToBlob, blobToFile, readCookie, isVideoUrl, createCookie } from '../../../utils/common';
import { DetailShare } from '../../../components/copyright/detailShare';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { Vh5Video } from '../../../components/videoPaler';
import { MINIPROGRAM_APPID } from '../../../utils/weixin';
import './index.scss';
import LazyLoad from 'vanilla-lazyload';
import { _track } from '../../../utils/track';
import { ImageInfo } from '../../../components/copyright/imageInfo';
import { DownloadTip } from '../../../components/downloadTip';
let lazyLoadInstance = null;
let copyright_showState = readCookie('copyright_showState');
// import { defaultProps, skinnyProps } from './data';;
const mapStateToProps = state => {
	return {
		galleryImgList: state.CopyrightGalleryReducers.galleryImgList,
		totalCount: state.CopyrightGalleryReducers.totalCount,
		pageIndex: state.CopyrightGalleryReducers.pageIndex,
		pageSize: state.CopyrightGalleryReducers.pageSize,
		isUpdate: state.CopyrightGalleryReducers.isUpdate,
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo
	};
};
let token = readCookie('userToken') || window['userToken'];
let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
function CopyrightGallery(props) {
	let praiseState = true;
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { baseInfo, galleryImgList = [], totalCount, pageIndex, pageSize, isUpdate } = useMappedState(mapState);
	//console.log ("galleryImgList",galleryImgList , totalCount , pageIndex);
	let dispatch = useDispatch();
	const [pageData, setPageData] = useState({
		activityType: 0, //2是集合相册, 1是单相册
		albumFinishAll: false, //数据是否全部请求完成
		totalCount: 0, //请求之后这个数不能为-1 ,如果为空是0
		isShowShare: false,
		sharedData: {},
		isShowQRcodeInstruction: false,
		QRContent: '',
		isShowDownload: false,
		isShowInstruction: false
	});
	let [playerOptions, setPlayerOptions] = useState({});
	const [imgInfo, setImgInfo] = useState({
		id: '',
		contentId: '',
		type: 1,
		userId: 11610,
		userNickname: '4119昵称',
		key: '',
		thumbKey: '',
		picDescription: '',
		description: '',
		submitTime: 0,
		crDate: 0,
		lat: null,
		city: '',
		width: 600,
		height: 885,
		size: 32513,
		authorUserName: null,
		authorUserId: null,
		workTraceResps: []
	});
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let [effectFlag, setEffectFlag] = useState(1);
	let [isDownloadTip, setIsDownloadTip] = useState(false);
	let [downloadItem, setDownloadItem] = useState({});
	// const [isUpdate ,  setUpdate] = useState(0);
	let handleLoadMore = resolve => {
		//console.log('loading.....');
		// let param = pageData.pageParam;
		// param.pageIndex = param.pageIndex + 1;
		console.log('pageSize', totalCount, pageIndex, pageSize);
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		dispatch(
			getGalleryImgList(
				{
					index: pageIndex + 1,
					limit: pageSize,
					status: 20,
					sort: -1,
					userId
				},
				data => {
					dispatch({
						type: ACITONCOPYRIGHT.SET_COPYRIGHT_GALLERYIMGVALLFLAG,
						payload: {
							isUpdate: 0
						}
					});
					lazyLoadInstance.update();
					_track({
						trackName: 'toutu_gallery_page',
						payload: {
							index: pageIndex + 1,
							limit: pageSize,
							page_action_name: 'gallery-tloader-list'
						}
					});
					resolve();
				}
			)
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	useEffect(() => {
		if (!cache || (effectFlag === 1 && galleryImgList.length === 0)) {
			//if (galleryImgList.length === 0 && token && userId) {
			setCache(true);
			setEffectFlag(2);
			dispatch(
				getGalleryImgList(
					{
						index: 1,
						limit: pageSize,
						status: 20,
						sort: -1,
						userId
					},
					() => {
						lazyLoadInstance.update();
						_track({
							trackName: 'toutu_gallery_page',
							payload: {
								index: 1,
								limit: pageSize,
								page_action_name: 'gallery-init-list'
							}
						});
					}
				)
			);
			dispatch(
				getWeixinConfig({ url: window.location.href }, data => {
					console.log('getWeixinConfig', data);
					configWeixin(data, {
						title: '投图',
						desc: '主题影像即时创作平台'
					});
					_track({
						trackName: 'toutu_gallery_page',
						payload: {
							index: 1,
							limit: pageSize,
							page_action_name: 'gallery-init-wxconfig'
						}
					});
				})
			);
		} else if (effectFlag === 1 && cache) {
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 0
				// ... more custom settings?
			});
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
		}
	}, [dispatch, pageSize, galleryImgList, props, cache, effectFlag]);
	useEffect(() => {
		if (!token || !userId) {
			history.push({
				pathname: '/vpmobile/copyright/login'
			});
			return;
		}
		lazyLoadInstance = new LazyLoad({
			elements_selector: '.lazy',
			load_delay: 200
			// ... more custom settings?
		});
	}, [dispatch, history]);
	let defaultProps = handleImgData(galleryImgList);
	console.log('handle..', galleryImgList, defaultProps);
	function onPlayer({ url, type }) {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					src: url,
					type: type || 'video/mp4'
				}
			],
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}
	function onToidetail(item, index) {
		let top = document.getElementsByClassName('tloader')[0].scrollTop;
		if (item.type === 2) {
			onPlayer({
				url: item.thumbVideoUrl,
				type: ''
			});
			return;
		}
		let objectProps = clone(defaultProps);
		let newItems = objectProps.items.filter(item => {
			if (item.type === 2) {
				return false;
			}
			return true;
		});
		// console.log('newItems', newItems);
		// objectProps.items = newItems;
		// let matchIndex = findIndex(newItems, ['id', item.id]);
		// console.log('matchIndex', matchIndex);
		let newArray = handleIndexData(galleryImgList, index);
		console.log('newArray', newArray);
		history.push({
			pathname: '/vpmobile/copyright/idetail',
			state: {
				defaultProps: newArray, //objectProps,
				index: 0, //matchIndex,
				pathname: `/vpmobile/copyright/gallery`,
				sectionDescription: item.sectionDescription,
				top
			}
		});
		_track({
			trackName: 'toutu_gallery_page',
			payload: {
				page_action_name: 'gallery-to-idetail',
				PicStorage_PictureShow: '全部版权页点击图片查看大图'
			}
		});
	}
	function uploadDownloadInfo(contentId) {
		let userId = readCookie('copyrightuserId');
		dispatch(
			sendDownloadInfo(
				{
					contentIds: [contentId],
					userId
				},
				data => {},
				data => {
					console.log('error data', data);
				}
			)
		);
	}

	function showQRCode(item) {
		if (pageData.isShowDownload) {
			return;
		}
		pageData.isShowDownload = true;
		setPageData({ ...pageData });

		// let _index = carouselIndex === -1 ? index : carouselIndex;
		let fd = new FormData();
		fd.append('appId', MINIPROGRAM_APPID);
		fd.append('downloadUrl', item.originalUrl);
		dispatch(
			getDownloadQRCode(
				fd,
				data => {
					pageData.isShowQRcodeInstruction = true;
					pageData.QRContent =
						'<div class="qrcode-wrap">' +
						'<img width="162" height="162" src="' +
						data.miniAppQrUrl +
						'" alt="小程序二维码" />' +
						'<div class="tip2">长按识别小程序码下载本视频</div>' +
						'</div>';
					setPageData(clone(pageData));
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
					// return '<div class="qrcode-wrap">' + '<img width="162" height="162" src="' + data.miniAppQrUrl + '" alt="小程序二维码" />' + '<div class="tip2">长按识别小程序码下载本图</div>' + '</div>';
					uploadDownloadInfo(item.contentId);
				},
				data => {
					console.log('error data', data);
					Toast.fail('生成小程序码失败');
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
				}
			)
		);
	}

	function getCurrentImgInfo(item) {
		console.log(item);
		// let item = items[index - 1];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				_track({
					trackName: 'toutu_idetail_page',
					payload: {
						...data,
						page_action_name: 'idetail-imginfo'
					}
				});
				setImgInfo(data);
				console.log('img info', data);
			})
		);
	}
	function onMore(item, index) {
		console.log(item, index);
		let textArray = ['视频信息', '下载视频', '取消'];
		ActionSheet.showActionSheetWithOptions(
			{
				options: textArray,
				//message: '上传照片、视频',
				maskClosable: true,
				wrapProps: {
					// onTouchStart: e => e.preventDefault()
				}
			},
			buttonIndex => {
				console.log(buttonIndex);
				if (buttonIndex === 0) {
					getCurrentImgInfo(item);
					pageData.isShowInstruction = true;
					setPageData(clone(pageData));
					//视频信息
				} else if (buttonIndex === 1) {
					// showQRCode(item);
					setDownloadItem(item);
					onOpenTip();
				}
			}
		);
	}
	function onOpenTip() {
		setIsDownloadTip(true);
	}
	function onOpenTipNext() {
		setIsDownloadTip(false);
		showQRCode(downloadItem);
	}
	function onCloseTip() {
		setIsDownloadTip(false);
	}
	function formatSource(list) {
		function formatItem(item) {
			let d = new Date(item.operateTime);
			let hour = String(d.getHours());
			let minute = String(d.getMinutes());
			let second = String(d.getSeconds());
			if (hour.length === 1) {
				hour = '0' + hour;
			}
			if (minute.length === 1) {
				minute = '0' + minute;
			}
			if (second.length === 1) {
				second = '0' + second;
			}
			return {
				time: hour + ':' + minute + ':' + second,
				operate: item.operate,
				comment: item.comment
			};
		}
		let stamps = [];
		let dataList = [];
		list.forEach(item => {
			let d = new Date(item.operateTime);
			let date = d.getDate();
			let month = d.getMonth() + 1;
			let year = d.getFullYear();
			let stamp = year + '.' + month + '.' + date;
			item = formatItem(item);
			if (!stamps.includes(stamp)) {
				stamps.push(stamp);
				dataList.push([item]);
			} else {
				dataList[dataList.length - 1].push(item);
			}
		});
		console.log([stamps, dataList]);
		return [stamps, dataList];
	}
	function source(resps) {
		let [stamps, dataList] = formatSource(resps);
		let iconMap = {
			SHOOT: '&#xe65d;',
			ORG_STMT: '&#xe660;',
			PUBLISH: '&#xe65c;'
		};
		function items(sourceList) {
			return sourceList.map(item => {
				return `<li>
						<span class="time">${item.time}</span>
						<span class="operate iconfont">${iconMap[item.operate] || ''}</span>
						<span class="comment">${item.comment}</span>
					</li>`;
			});
		}
		let list = stamps.map((stamp, index) => {
			return `<ul>
					<h3 class="date">${stamp}</h3>
					${items(dataList[index]).join('')}
				</ul>`;
		});

		return `<ul class="workTraceResps">${list.join('')}</ul>`;
	}

	function imageInfo(info) {
		//let { imgLayout = 'JPEG', imgSize = '4.3MB', imgPx = '6140 × 4912 像素', dateString = '2020年02月04日 12:00', author = 'Frank Wang' } = info || {};
		function videotype(key) {
			let index = key.lastIndexOf('.') + 1;
			return key.slice(index);
		}
		let equipment = ''; // 传输设备
		let location = imgInfo.city;
		let originalDocId = imgInfo.contentId;
		let isOriginal = imgInfo.isOriginal === 20; // 10：否  20：是
		let imgLayout = imgInfo.type === 1 ? 'JPEG' : videotype(imgInfo.key);
		let imgSize = parseFloat(imgInfo.size / 1024).toFixed(2) + 'KB';
		let imgPx = imgInfo.width + ' x ' + imgInfo.height + ' 像素';
		let dateString = moment(imgInfo.submitTime).format('YYYY-MM-DD HH:mm');
		let author = imgInfo.authorUserName || '未知';
		let resps = imgInfo.workTraceResps;
		return (
			'<div class="img-info-dialog">' +
			'<ul>' +
			(equipment ? `<li><label>传输设备</label><span>${equipment}</span></li>` : '') +
			'    <li>' +
			'        <label>视频格式</label>' +
			'        <span>' +
			imgLayout +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频大小</label>' +
			'        <span>' +
			imgSize +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>拍摄地点</label>' +
			'        <span>' +
			location +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频尺寸</label>' +
			'        <span>' +
			imgPx +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>原始文档ID</label>' +
			'        <span>' +
			originalDocId +
			'</span>' +
			'    </li>' +
			'</ul>' +
			'<ul>' +
			'    <li>' +
			'        <label>视频溯源</label>' +
			(isOriginal ? '<div class="original"><span class="iconfont original-icon">&#xe660;</span><span>原创</span><div>' : '') +
			'    </li>' +
			// '    <li>' +
			// '        <label>照片提交于</label>' +
			// '        <span>' +
			// dateString +
			// '</span>' +
			// '    </li>' +
			// '    <li>' +
			// '        <label>照片提交者</label>' +
			// '        <span>' +
			// author +
			// '</span>' +
			// '    </li>' +
			'</ul>' +
			source(resps) +
			// '<ul>' +
			// '    <li>' +
			// '        <label>版权说明</label>' +
			// '        <span>可免费使用，但不可用于商业+用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权</span>' +
			// '    </li>' +
			// '</ul>' +
			'</div>'
		);
	}
	function dialogFooter() {
		pageData.isShowInstruction = false;
		setPageData(clone(pageData));
	}
	function dialogQrCodeFooter() {
		pageData.isShowQRcodeInstruction = false;
		pageData.isShowDownload = false;
		setPageData(clone(pageData));
	}
	function onShare(item, index) {
		_track({
			trackName: 'toutu_gallery_page',
			payload: {
				id: item.id,
				shareType: '作品',
				page_action_name: 'gallery-share'
			}
		});
		let shareData = {
			fromAvatar: item.avatar,
			fromName: item.nickname,
			// topicName: item.section,
			// title: item.description,
			// sectionId: item.sectionId,
			// contentId: item.contentId,
			title: item.sectionDescription,
			thumbKey: item.thumbKey || item.smallUrl
			// list: [{
			// 	key: item.url,
			// 	description: item.description
			// }]
		};
		if (item.mutil || isVideoUrl(item.url)) {
			shareData.sectionId = item.sectionId;
			shareData.list = defaultProps.items[index].responseList;
		} else {
			shareData.contentId = item.contentId;
			shareData.list = [
				{
					key: item.url,
					description: item.description
				}
			];
		}
		pageData.sharedData = shareData;
		pageData.isShowShare = true;
		setPageData({ ...pageData });
		console.log('showShare', shareData);
	}
	function closeShare() {
		pageData.isShowShare = false;
		setPageData({ ...pageData });
	}
	function toCopyrightNotice() {
		history.push({
			pathname: '/vpmobile/copyright/notice'
		});
	}
	function onPraise(item, index) {
		if (!praiseState) {
			return;
		}
		praiseState = false;
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					Modal.alert('提示', '登录过期，是否去登录？', [
						{ text: '再看看', onPress: () => {} },
						{
							text: '去登录',
							onPress: () => {
								window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent(window.location.pathname);
							}
						}
					]);
					return;
				}
				console.log('gallery', item);
				dispatch(
					setGalleryImgPraise(
						{
							operation: item.likeStatus === 0 ? 1 : 0,
							postId: item.sectionId,
							userId: baseInfo.id,
							index,
							name: 'gallery'
						},
						data => {
							praiseState = true;
						},
						data => {
							praiseState = true;
						}
					)
				);
			})
		);
	}
	console.log('defaultProps', defaultProps);
	return (
		<div className="copyright copyright-gallery">
			<div className="gallery-top-nav">
				{/* <ul>
					<li
						onClick={() => {
							_track({
								trackName: 'toutu_gallery_page',
								payload: {
									PicStorage_Action: '头图标签'
								}
							});
							history.push({ pathname: '/vpmobile/copyright/activitylist' });
						}}>
						头图
					</li>
					<li className="active">
						<i className="all-img-icon"></i>
						<div className="line"></div>
					</li>
				</ul> */}
				<div className="header-activity">
					<div className="search-input">
						<Icon className="search-icon" type="search" size="sm"></Icon>
						<InputItem
							className="search-inner"
							placeholder="搜索图片、视频、活动"
							onFocus={() => {
								history.push({ pathname: '/vpmobile/copyright/search/4' });
							}}></InputItem>
					</div>
					<div className="tab-activity">
						<div
							className="tab-item"
							onClick={() => {
								_track({
									trackName: 'toutu_gallery_page',
									payload: {
										PicStorage_Action: '头图标签'
									}
								});
								history.push({ pathname: '/vpmobile/copyright/activitylist' });
							}}>
							头图
						</div>
						<div className="tab-item active">全部版权影像</div>
					</div>
				</div>
			</div>
			{copyright_showState === 'true' ? (
				<div className="show-list">
					<Tloader
						initializing={2}
						onRefresh={handleRefresh}
						hasMore={true}
						onLoadMore={handleLoadMore}
						autoLoadMore={!pageData.albumFinishAll /*false不会触发onLoadMore*/}
						className="tloader some class">
						<Vfalls {...defaultProps} isDesc={true} onClick={onToidetail} onMore={onMore} onShare={onShare} onPraise={onPraise} update={isUpdate} />
						{pageIndex * pageSize < totalCount ? <Loading /> : <div className="more-text">---- 我是底线，不能更低了 ----</div>}
					</Tloader>
				</div>
			) : (
				''
			)}
			<VBottomNav activeName="activitylist" />
			{copyright_showState === 'true' || !token || !userId ? (
				''
			) : (
				<VDialogText
					className="dialog-text"
					show={true}
					title={'查看更多版权图片'}
					comfirmtext={'确定'}
					callback={() => {
						history.push({
							pathname: '/vpmobile/copyright/activitylist'
						});
					}}>
					<div className="black-tip">
						获取版权图片需进行身份认证，请发送
						<br />
						“投图平台身份认证” 至邮箱
						<br />
						<span className="email">hu.gao@v.photos</span>
						<br />
						工作人员会在1个工作日内联系您
						<br />
						<img src="https://gallerytemplate.vphotos.cn/copyright/service-qrcode.jpg" alt="QRCode" className="qrcode-img" />
						<span className="qrcode-tips">
							或直接扫码加好友
							<br />
							“投图微信”
						</span>
					</div>
				</VDialogText>
			)}
			{isDownloadTip ? <DownloadTip isDownloadTip={isDownloadTip} imgInfo={[downloadItem]} index={0} onClose={onCloseTip} onOpenTipNext={onOpenTipNext}></DownloadTip> : ''}
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
			{/* {pageData.isShowInstruction ? <TextDialog title="视频信息" text={imageInfo()} clickFooter={dialogFooter} footer={'关闭'} /> : ''} */}
			{pageData.isShowInstruction ? <ImageInfo text={imageInfo()} clickFooter={dialogFooter} clickIcon={toCopyrightNotice} footer={'关闭'} isVideo={true} /> : ''}
			{pageData.isShowShare ? <DetailShare data={pageData.sharedData} onClose={closeShare} /> : ''}
			{pageData.isShowQRcodeInstruction ? <TextDialog title="视频下载" text={pageData.QRContent} clickFooter={dialogQrCodeFooter} footer={'关闭'} /> : ''}
		</div>
	);
}
export { CopyrightGallery };
